import { Tooltip } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import BlurredText from 'app/components/elements/wrappers/blurred_text';
import URL from 'app/constants/route_urls';
import Storage from 'app/utils/storage/local';
import STORAGE_CONSTANTS from 'app/constants/storage';

const ObscuredQuoteWrapper = ({
    text,
    fontSize = '14px',
    blurAmount = 3.5,
    color = '#090b0b',
    font = 'Basier Circle',
    fontWeight = '400',
    horizontalPadding = 5,
    listing,
    textHidden = false,
    verticalPadding = 4,
    showTooltip = true,
}: {
    text: string;
    fontSize?: string;
    fontWeight?: string;
    font?: string;
    color?: string;
    blurAmount?: number;
    horizontalPadding?: number;
    listing: any;
    textHidden?: boolean;
    verticalPadding?: number;
    showTooltip?: boolean;
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isPremiumListing = listing?.is_premium;

    if (isPremiumListing) return textHidden ? '' : text;

    return (
        <Tooltip
            title={
                isPremiumListing || !showTooltip ? undefined : (
                    <span>
                        This information is only available to Premium listings.{' '}
                        <span
                            role='link'
                            aria-hidden='true'
                            className='link-inline'
                            onClick={() => {
                                Storage.set(
                                    STORAGE_CONSTANTS.listingPaymentRedirect,
                                    location.pathname || URL.BUSINESS_LISTINGS
                                );
                                navigate(`${URL.LISTING_UPGRADE}/${listing?.uuid}/`, {
                                    state: { listing },
                                });
                            }}
                        >
                            Upgrade to Premium
                        </span>
                    </span>
                )
            }
        >
            <span className='vendor-quote-requests__text-wrapper'>
                <BlurredText
                    text={textHidden ? '' : text}
                    blurAmount={blurAmount}
                    color={color}
                    font={font}
                    fontSize={fontSize}
                    fontWeight={fontWeight}
                    horizontalPadding={horizontalPadding}
                    verticalPadding={verticalPadding}
                />
            </span>
        </Tooltip>
    );
};

export default ObscuredQuoteWrapper;
